import React, { PureComponent } from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import { throttle } from 'lodash';

import Storage from '../../../../services/Storage';
import Button from '../../../../components/Button';

const STORAGE_TIMER_NAME = 'inactivityTimer';
export default class InactivityTimerBanner extends PureComponent {
  static propTypes = {
    config: PropTypes.shape({
      tokenItemName: PropTypes.string.isRequired,
      inactivityLimitMs: PropTypes.number.isRequired,
      inactivityAfterModal: PropTypes.number.isRequired,
      isInspectorArm: PropTypes.bool.isRequired,
    }).isRequired,
    token: PropTypes.string,
    logoutRequest: PropTypes.func.isRequired,
  };

  state = {
    isOpen: false,
    timer: null,
  };

  checkTimer = null;

  updateInactivityTimer = throttle(() => {
    const {
      token,
      config: { inactivityLimitMs },
    } = this.props;
    if (!this.state.isOpen && token) {
      const localTimer = Date.now() + inactivityLimitMs;
      Storage.setItem(STORAGE_TIMER_NAME, localTimer);
      this.setTimerToCheckActivity(localTimer);
      this.setState({ timer: localTimer });
    } else {
      clearTimeout(this.checkTimer);
      this.checkTimer = null;
      this.setState({ timer: null });
      Storage.removeItem(STORAGE_TIMER_NAME);
    }
  }, 1000);

  componentDidMount() {
    if (!this.props.config.isInspectorArm) {
      ['mousemove', 'touchstart', 'keydown'].forEach((eventName) => {
        window.addEventListener(eventName, this.updateInactivityTimer);
      });
      window.addEventListener('visibilitychange', this.updateGlobalTimeout);
    }
  }

  componentWillUnmount() {
    ['mousemove', 'touchstart', 'keydown'].forEach((eventName) => {
      window.removeEventListener(eventName, this.updateInactivityTimer);
      window.removeEventListener('visibilitychange', this.updateGlobalTimeout);
    });
  }

  updateGlobalTimeout = () => {
    const { token } = this.props;
    const unionTimer = Storage.getItem(STORAGE_TIMER_NAME);
    if (unionTimer && token) {
      const { timer } = this.state;
      if (timer >= unionTimer) {
        this.actionsByLocalTimer();
      } else {
        this.setState({ isOpen: false });
        this.actionsByGlobalTimer();
      }
    } else {
      clearTimeout(this.checkTimer);
      this.checkTimer = null;
    }
  };

  actionsByLocalTimer = () => {
    const { inactivityAfterModal } = this.props.config;
    const { timer } = this.state;

    const currentTime = Date.now();
    const logoutDelay = inactivityAfterModal;

    if (timer >= currentTime) {
      this.setTimerToCheckActivity(timer);
    } else if (timer + logoutDelay >= currentTime) {
      this.handleOpenModal();
      this.setTimerToCheckActivity(timer + logoutDelay);
    } else {
      this.handleLogout();
    }
  };

  actionsByGlobalTimer = () => {
    const { inactivityAfterModal } = this.props.config;
    const currentTime = Date.now();
    const logoutDelay = inactivityAfterModal;
    const unionTimer = Storage.getItem(STORAGE_TIMER_NAME);

    this.setState({ timer: unionTimer });

    if (unionTimer >= currentTime) {
      this.setTimerToCheckActivity(unionTimer);
    } else if (unionTimer + logoutDelay >= currentTime) {
      this.handleOpenModal();
      this.setTimerToCheckActivity(unionTimer + logoutDelay);
    } else {
      this.handleLogout();
    }
  };

  setTimerToCheckActivity = (newTimer) => {
    const { token } = this.props;
    clearTimeout(this.checkTimer);
    this.checkTimer = null;

    if (token) {
      const delayAtSeconds = newTimer - Date.now();
      this.checkTimer = setTimeout(() => this.updateGlobalTimeout(), delayAtSeconds);
    }
  };

  handleOpenModal = () => {
    this.setState({ isOpen: true });
  };

  handleLogout = () => {
    this.props.logoutRequest();
    this.setState({ isOpen: false });
    clearTimeout(this.checkTimer);
    this.checkTimer = null;
    Storage.removeItem(STORAGE_TIMER_NAME);
  };

  handleCheck = () => {
    this.setState({ isOpen: false });
    Storage.removeItem(STORAGE_TIMER_NAME);
    clearTimeout(this.checkTimer);
    this.checkTimer = null;
  };

  render() {
    const { isOpen } = this.state;
    const { token } = this.props;
    if (!token) this.handleCheck();
    return (
      <Modal
        key="inactive-modal"
        isOpen={isOpen && token}
        style={{
          overlay: {
            zIndex: 5000,
            backgroundColor: 'rgba(74,74,74,0.3)',
          },
          content: {
            border: 'none',
            backgroundColor: 'rgba(0,0,0,0)',
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
          },
        }}
      >
        <div className="mfp-container mfp-inline-holder">
          <div className="mfp-content">
            <div className="popup popup__750" id="info">
              <a className="mfp-close popup_close" onClick={this.handleLogout} />
              <div className="popup_wrapper popup_wrapper__white info">
                <h5>
                  Время сессии заканчивается. Будет выполнен автоматический выход.
                  <br />
                  Вы хотите продолжить работу?
                </h5>
                <div className="form form_buttons">
                  <div className="steps_button">
                    <Button onClick={this.handleLogout} value="Нет" hasWrapper={false} />
                    <Button onClick={this.handleCheck} value="Да" hasWrapper={false} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}
